<template>
    <div class="m-3">
        <h1>
            {{ title }}
        </h1>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-5">
            <div class="flex flex-col gap-2">
                <p class="text-2xl text-main-600">
                    {{ $t('labels.customer') }}
                </p>

                <p class="font-bold">
                    {{ dataOrder.customerName }}
                </p>
                <p v-if="dataOrder.customerAddress">
                    Địa chỉ: {{ dataOrder.customerAddress }}
                </p>
                <p v-if="dataOrder.contactName">
                    {{ $t('labels.businessContact') }}: {{ dataOrder.contactName }} - {{ dataOrder.contactPhone }} - {{ dataOrder.contactEmail }}
                </p>
                <p v-if="dataOrder.logisticContactName">
                    {{ $t('labels.logisticContact') }}: {{ dataOrder?.logisticContactName }} - {{ dataOrder?.logisticContactPhone }} -
                    {{ dataOrder?.logisticContactEmail }}
                </p>

                <div class="flex flex-wrap">
                    <p class="font-bold w-52 float-start">
                        Trạng thái vận chuyển:
                    </p>
                    <hts-status
                        module="orderStatus"
                        :status="dataOrder.status"
                        size="medium"
                        label="" />
                </div>
            </div>
            <div class="flex flex-col gap-4">
                <p class="text-2xl text-main-600">
                    {{ $t('labels.route') }}
                </p>
                <ul
                    v-if="trip.positions && trip.positions.length"
                    class="steps steps-vertical w-full">
                    <li
                        v-for="(item, index) in (trip.positions as any[])"
                        :key="index"
                        data-content=" "
                        class="step float w-full">
                        <div class="flex items-center justify-center w-full">
                            <div class="items-center w-full text-left py-3">
                                <p class="font-bold">
                                    {{ item.fullNameNode }}
                                </p>
                                <p v-if="item.locationName">
                                    {{ item.locationName }}
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="flex flex-col gap-4">
                <p class="text-2xl text-main-600">
                    {{ $t('labels.otherInformation') }}
                </p>
                <div>
                    <p class="font-bold">
                        {{ $t('labels.commodity') }}
                    </p>
                    <p>
                        <span class="text-no first-letter:capitalize">
                            {{ dataOrder.commodityCategory }}
                        </span>
                        <span v-if="dataOrder.commodityCategory">
                            :
                        </span>
                        <span class="first-letter:capitalize">
                            {{ dataOrder.commodityName }}
                        </span>
                        <span v-if="dataOrder.goodsStatusName">
                            -
                        </span>
                        <span class="first-letter:capitalize">
                            {{ dataOrder.goodsStatusName }}
                        </span>
                    </p>
                </div>

                <div>
                    <template v-if="dataOrder.transportation === 'NON_CONTAINER'">
                        <p class="font-bold">
                            {{ $t('labels.vehicleType') }}
                        </p>
                        <p>
                            {{ dataOrder.vehicleCategoryName }}
                        </p>
                    </template>
                    <template v-else>
                        <p class="font-bold">
                            {{ $t('labels.containerType') }}
                        </p>
                        <p>
                            <span>
                                {{ dataOrder.contCategory }} feet
                            </span>
                            <span v-if="dataOrder.headContainer || dataOrder.mergeContainer">
                                - {{ dataOrder.headContainer ? `${$t('labels.headContainer')}` : '' }}{{ dataOrder.headContainer && dataOrder.mergeContainer ? ',' : ''
                                }}{{ dataOrder.mergeContainer ? `${$t('labels.mergeContainer')} ` : '' }}
                            </span>
                        </p>
                    </template>
                </div>

                <div>
                    <p class="font-bold">
                        {{ $t('labels.productivity') }}
                    </p>
                    <p>
                        {{ $formatters.formatNumber(dataOrder.productivityOrder || 0) }}
                        {{ dataOrder.transportation === 'NON_CONTAINER' ? $t('labels.vehicle') : $t('labels.container') }}
                    </p>
                </div>
            </div>
        </div>

        <div class="mx-5 mb-20">
            <hts-ui-tabs
                v-model="tapSelected"
                :tabs="tabs">
                <template #default="{ key, label }: any">
                    <div class="relative">
                        {{ label }}
                        <!--
                          <template v-if="key === 'driver-notifications' && hasDriverAlert">
                          <span class="absolute text-sm -top-2 -right-6 text-white bg-error-500 font-medium border px-2 rounded-full">
                          {{ hasDriverAlert }}
                          </span>
                          </template>
                          <template v-if="key === 'alerts' && hasAlert">
                          <span class="absolute text-sm -top-2 -right-6 text-white bg-error-500 font-medium border px-2 rounded-full">
                          {{ hasAlert }}
                          </span>
                          </template>
                        -->
                    </div>
                </template>
            </hts-ui-tabs>

            <div
                v-show="tapSelected === 'monitoring'"
                class="mb-1">
                <!--
                  <info-planning
                  v-if="false"
                  ref="tabPlanning"
                  v-model:editable="planEditable"
                  :journey="journey"
                  :order="dataOrder"
                  @change="journeyChanged" />
                -->

                <travel-detail
                    v-if="trip.travelDetails"
                    ref="travelDetail"
                    :journey="trip"
                    :visibel="true"
                    :travel-details="trip.travelDetails"
                    :positions-and-waiting-tasks="trip.positionsAndWaitingTasks" />

                <!--
                  <div v-if="tapSelected === 'monitoring'">
                  <div class="flex gap-3 mb-5">
                  <div
                  ref="monitoring"
                  class="w-5/12 h-full bg-slate-100">
                  <div class="bg-gray-200">
                  <transportation-info
                  :journey="journey"
                  class="h-[220px]" />
                  </div>
                  <info-travel-step
                  :journey="journey"
                  class="min-h-[800px]"
                  @modify="openPlanModify" />
                  </div>
                  <div class="w-7/12 overflow-hidden">
                  <info-travel-map
                  v-if="showMap"
                  :show-location="showMapLocation"
                  :journey="journey" />
                  <info-travel-tabs
                  :journey="journey"
                  :style="{
                  'max-height': monitoringHeight - (showMap ? 500 : 0) + 'px',
                  height: monitoringHeight - (showMap ? 500 : 0) + 'px'
                  }" />
                  </div>
                  </div>
                -->
            </div>
        </div>

    <!-- trip.travelDetails: {{ trip.travelDetails }} -->
    </div>
</template>
<script lang="ts" setup>
import { onMounted } from 'vue'
import TravelDetail from './-component/travel-detail.vue'
import Status from '~/components/status.vue'

const trip = ref({} as { [key: string]: any })
const tapSelected = ref('')

const dataOrder = computed(() => trip.value?.order || {})
const tripCode = computed(() => useRoute().params.code)
const title = computed(() => `Chi tiết chuyến hàng #${tripCode.value}`)

onMounted(async () => {
  if (Array.isArray(tripCode.value)) {
    // Nếu tripCode.value là một mảng có ít nhất một phần tử
    if (tripCode.value.length > 0) {
      trip.value = await getTrip(tripCode.value[0] || '')
    }
  } else {
    // Nếu tripCode.value không phải mảng hoặc mảng rỗng
    trip.value = await getTrip(tripCode.value || '')
  }

  tapSelected.value = 'monitoring'
})

const url = {
  method: 'get',
  url: '/customer/trip/CODE'
}

const tabs = ref([{ key: 'monitoring', label: $t('labels.monitoring'), permission: true }])

const getTrip = async (code: string) => {
  const response = await $api(url, { uriParams: { CODE: code } })
  const { data } = response

  return (data?.value || {}).data || {}
}
</script>
